export default {
    reports: state => {
        return state.reports;
    },
}
